import { Component3D, Mesh3D, RegisterComponent } from 'feng3d-three';
import { VertexNormalsHelper } from '../thirdparty/three/imports';

declare module 'feng3d-three'
{
    interface ComponentMap { VertexNormalsHelper3D: VertexNormalsHelper3D; }
}

/**
 * 包装`three`中`VertexNormalsHelper`。
 */
@RegisterComponent({ name: 'VertexNormalsHelper3D' })
export class VertexNormalsHelper3D extends Component3D
{
    _helper: VertexNormalsHelper;

    object: Mesh3D;
    size?: number;
    hex?: number;

    init()
    {
        super.init();

        // 更新全局矩阵
        this.object._mesh.updateWorldMatrix(true, false);

        this._helper = new VertexNormalsHelper(this.object._mesh, this.size, this.hex);

        this._entity._group.add(this._helper);
    }

    destroy(): void
    {
        this._entity._group.remove(this._helper);

        this._helper.dispose();
        this._helper = null;

        super.destroy();
    }

    update()
    {
        this._helper.update();
    }
}
